import { render, staticRenderFns } from "./lazyblock_target_list.vue?vue&type=template&id=6ac1a240&scoped=true"
import script from "./lazyblock_target_list.vue?vue&type=script&lang=js"
export * from "./lazyblock_target_list.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_target_list.vue?vue&type=style&index=0&id=6ac1a240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac1a240",
  null
  
)

export default component.exports